import React from 'react'
import { Typography, useDimensions } from '@telavita-core/react-design-kit'

import { 
  ScheduleReminderSettings,
  AddressSettings, 
  FamilyContactSettings 
} from '../components'

import * as S from './styles'

export const PatientSettings: React.FC = () => {
  const { isMobile } = useDimensions()

  return (
    <S.Container>
      <S.Header>
        <Typography
          id='settingsTitle'
          variant={isMobile ? 'header4' : 'header2'}
          center={isMobile}
        >
          Configurações
        </Typography>
      </S.Header>

      <S.SettingsContainer>
        <ScheduleReminderSettings />
        <AddressSettings />
        <FamilyContactSettings />
      </S.SettingsContainer>
    </S.Container>
  )
}